jQuery(function ($) {
  /* =====================================================
     UNIQUE VARIABLES (SCOPED)
  ===================================================== */
  var $popupGalleryOuter = $(".product_gallery-popup-outer");
  var popupAnimTime = 300;
  var popupGallerySwiper = null;
  var popupClickedWasVideo = false;

  /* =====================================================
     GET ACTIVE (VISIBLE) MAIN CAROUSEL
  ===================================================== */
  function getActiveGalleryCarousel() {
    return $(".main-product_gallerybox")
      .filter(function () {
        return $(this).css("display") !== "none";
      })
      .find(".main-product_gallery_carousel")
      .first();
  }

  /* =====================================================
     VIDEO HELPERS
  ===================================================== */
  function popupPauseAllVideos() {
    $popupGalleryOuter.find("video").each(function () {
      try {
        this.pause();
        this.currentTime = 0;
      } catch (e) {}
    });
  }

  function popupPlayActiveVideo() {
    if (!popupGallerySwiper) return;

    const activeSlide =
      popupGallerySwiper.slides[popupGallerySwiper.activeIndex];
    if (!activeSlide) return;

    const video = activeSlide.querySelector("video");
    if (!video) return;

    video.muted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("loop", "");

    video.load();

    setTimeout(() => {
      const playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {});
      }
    }, 120);
  }

  /* =====================================================
     BUILD POPUP GALLERY FROM ACTIVE CAROUSEL ONLY
  ===================================================== */
  function buildPopupGallery(startIndex) {
    const $popupWrapper = $(".product_gallery-popup-swiper .swiper-wrapper");
    $popupWrapper.empty();

    const $activeCarousel = getActiveGalleryCarousel();
    if (!$activeCarousel.length) return;

    $activeCarousel.find(".swiper-slide").each(function () {
      const $contentClone = $(this).children().first().clone(true, true);
      $popupWrapper.append(
        $('<div class="swiper-slide"></div>').append($contentClone)
      );
    });

    if (popupGallerySwiper) {
      popupGallerySwiper.destroy(true, true);
      popupGallerySwiper = null;
    }

    popupGallerySwiper = new Swiper(".product_gallery-popup-swiper", {
      slidesPerView: 1,
      loop: false,
      grabCursor: true,
      navigation: {
        nextEl: ".PopupGallery.swiper-button-next",
        prevEl: ".PopupGallery.swiper-button-prev",
      },
      on: {
        init(swiper) {
          requestAnimationFrame(() => {
            swiper.slideTo(startIndex, 0, false);
            popupPauseAllVideos();

            setTimeout(() => {
              popupPlayActiveVideo();
            }, 150);
          });
        },
        slideChange() {
          popupPauseAllVideos();
          popupPlayActiveVideo();
        },
      },
    });
  }

  /* =====================================================
     FIND CLICKED SLIDE INDEX (ACTIVE CAROUSEL ONLY)
  ===================================================== */
  function getCarouselIndexFromClick(clickedEl) {
    const $clicked = $(clickedEl);
    const clickedImgSrc = $clicked.is("img") ? $clicked.attr("src") : null;

    const clickedVideoSrc = $clicked
      .closest(".video-autoplay-wrapper")
      .find("source")
      .attr("src");

    let foundIndex = 0;
    const $activeCarousel = getActiveGalleryCarousel();

    $activeCarousel.find(".swiper-slide").each(function (index) {
      const slideImgSrc = $(this).find("img").attr("src");
      const slideVideoSrc = $(this).find("source").attr("src");

      if (
        (clickedImgSrc && slideImgSrc === clickedImgSrc) ||
        (clickedVideoSrc && slideVideoSrc === clickedVideoSrc)
      ) {
        foundIndex = index;
        return false;
      }
    });

    return foundIndex;
  }

  /* =====================================================
     OPEN POPUP
  ===================================================== */
  function openPopupGallery(startIndex) {
    buildPopupGallery(startIndex);

    $("html").css("overflow", "hidden");
    $popupGalleryOuter.css("display", "flex");

    requestAnimationFrame(() => {
      $popupGalleryOuter.addClass("active");

      if (popupClickedWasVideo) {
        setTimeout(() => {
          popupPlayActiveVideo();
          popupClickedWasVideo = false;
        }, 250);
      }
    });
  }

  /* =====================================================
     CLOSE POPUP
  ===================================================== */
  function closePopupGallery() {
    popupPauseAllVideos();
    $popupGalleryOuter.removeClass("active");

    setTimeout(() => {
      $popupGalleryOuter.css("display", "none");
      $("html").css("overflow", "visible");
    }, popupAnimTime);
  }

  /* =====================================================
     CLICK HANDLER (ALL GALLERY TYPES)
  ===================================================== */
  $(".ts-product__gallery-wrapper-outer").on(
    "click",
    "img, .video-autoplay-wrapper",
    function () {
      if ($(this).closest(".main-product_gallery_carousel-thumbs").length) {
        return;
      }
      if ($(this).closest(".MainGallery.swiper-button-next").length) {
        return;
      }

      if ($(this).closest(".MainGallery.swiper-button-prev").length) {
        return;
      }

      popupClickedWasVideo = $(this).is(".video-autoplay-wrapper");

      const startIndex = getCarouselIndexFromClick(this);
      openPopupGallery(startIndex);
    }
  );

  /* =====================================================
     CLOSE INTERACTIONS
  ===================================================== */
  $popupGalleryOuter.on(
    "click",
    ".product_gallery-popup-close",
    closePopupGallery
  );

  $popupGalleryOuter.on("click", function (e) {
    if (!$(e.target).closest(".product_gallery-popup-inner, video").length) {
      closePopupGallery();
    }
  });

  $(document).on("keyup", function (e) {
    if (e.key === "Escape") closePopupGallery();
  });
});
